var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 43.283,
    height: 43.698,
    viewBox: "0 0 43.283 43.698",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "star_5_",
    "data-name": "star (5)",
    d: "M43.17,17.005a2.324,2.324,0,0,0-1.98-1.666L28.7,14.144,23.757,1.963a2.256,2.256,0,0,0-4.231,0l-4.94,12.179-12.495,1.2A2.329,2.329,0,0,0,.113,17.005,2.506,2.506,0,0,0,.786,19.58L10.229,28.3,7.444,41.226a2.489,2.489,0,0,0,.895,2.5,2.19,2.19,0,0,0,2.527.116l10.776-6.785,10.772,6.785a2.2,2.2,0,0,0,2.529-.116,2.491,2.491,0,0,0,.895-2.5L33.052,28.3,42.5,19.581A2.509,2.509,0,0,0,43.17,17.005Zm0,0",
    transform: "translate(0 -0.492)",
    fill: "#eac676",
    opacity: 0.998
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.27c759d8.svg";
export { ForwardRef as ReactComponent };